var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoiTh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 350,
    viewBox: "0 0 353 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6471_7837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.877 149.796L200.121 0.177246V120.941C200.121 142.315 222.207 149.083 233.251 149.796H351.877Z",
    fill: "url(#paint0_linear_6471_7837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6126 101.7C8.39882 175.227 40.8751 236.002 59.0431 258.802C44.0851 273.407 12.2454 304.328 4.55077 311.168C-3.14389 318.007 0.632189 326.842 3.48206 330.404C5.97569 332.898 12.8866 339.595 20.5813 346.435C28.276 353.274 38.7493 345.722 43.0241 341.092L92.1843 292.999C136.641 326.343 201.192 323.279 227.91 317.58C334.78 295.351 355.085 196.46 351.878 149.794H302.719C306.993 195.107 281.701 232.084 268.52 243.84C213.802 289.152 150.25 271.982 127.451 258.802C99.6652 247.046 65.0326 193.611 76.1538 138.037C91.5523 61.0913 165.925 47.1983 200.121 47.1983V0.17606C94.3198 -4.10186 48.0125 70.7073 36.6126 101.7Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.814 88.8774H127.518C123.938 88.8774 121.036 91.7793 121.036 95.3589V101.633C121.036 105.212 123.938 108.114 127.518 108.114H180.814C184.394 108.114 187.296 105.212 187.296 101.633V95.3589C187.296 91.7793 184.394 88.8774 180.814 88.8774Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.814 129.488H127.518C123.938 129.488 121.036 132.39 121.036 135.969V142.243C121.036 145.823 123.938 148.724 127.518 148.724H180.814C184.394 148.724 187.296 145.823 187.296 142.243V135.969C187.296 132.39 184.394 129.488 180.814 129.488Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.486 172.235H127.518C123.938 172.235 121.036 175.137 121.036 178.716V184.99C121.036 188.57 123.938 191.472 127.518 191.472H253.486C257.066 191.472 259.968 188.57 259.968 184.99V178.716C259.968 175.137 257.066 172.235 253.486 172.235Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.486 212.845H127.518C123.938 212.845 121.036 215.747 121.036 219.327V225.6C121.036 229.18 123.938 232.082 127.518 232.082H253.486C257.066 232.082 259.968 229.18 259.968 225.6V219.327C259.968 215.747 257.066 212.845 253.486 212.845Z",
    fill: "#A200FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6471_7837",
    x1: 200.121,
    y1: 149.796,
    x2: 349.725,
    y2: -1.94471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6471_7837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352.593,
    height: 350,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoiTh);
export default __webpack_public_path__ + "static/media/COI_TH.fb5ea4666f59069d334bdd6e724acbae.svg";
export { ForwardRef as ReactComponent };